import { render, staticRenderFns } from "./app-install-template.vue?vue&type=template&id=064b6b8a&"
import script from "./app-install-template.vue?vue&type=script&lang=js&"
export * from "./app-install-template.vue?vue&type=script&lang=js&"
import style0 from "./app-install-template.vue?vue&type=style&index=0&id=064b6b8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports